export default __webpack_public_path__ + "2a05c03654d9504a9131e914c74575e3.png";